// extracted by mini-css-extract-plugin
export default {"displayImage":"App_displayImage__vLnj0","card":"App_card__1zT54"};